<!-- Button -->
    <button class="mat-mdc-user-icon-button">
        <span class="flex items-center">
            <mat-icon style="min-width: 40px;"
                class="enfinty-icon"
                [svgIcon]="'heroicons_outline:user-circle'"
            ></mat-icon>

            <span
                class="text-lg ml-1 hidden lg:block truncate capitalize"
                [matMenuTriggerFor]="userActions"
                >{{userName}}</span
            >
            <!-- <button > -->
            <mat-icon
                class="mt-1"
                mat-icon-button
                [matMenuTriggerFor]="userActions"
                [svgIcon]="'mat_outline:keyboard_arrow_down'"
            ></mat-icon>
            <!-- </button> -->
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item class="hover:bg-primary hover:text-white">
            <span class="flex flex-col leading-none">
                <span>Signed as</span>
                <span class="mt-1.5 text-md font-medium capitalize">{{userName}}</span>
            </span>
        </button>
        <mat-divider class=""></mat-divider>
        <button mat-menu-item class="hover:bg-primary hover:text-white"  (click)="redirectToProducts()" >
            <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
            <span>Profile</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button
            mat-menu-item
            class="hover:bg-primary hover:text-white"
            (click)="signOut()"
        >
            <!-- <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon> -->
            <span>Sign Out</span>
        </button>
    </mat-menu>
